import React, { PureComponent } from 'react'
import { observer } from 'mobx-react'

import ProductTypeLicence from './ProductTypeLicence'
import LicenceManagerStore from './LicenceManagerStore'
import Anchor from '../../../UniformComponents/Anchor'
import Select from '../../form/Select'

import './licences.scss'

@observer
class LicenceManager extends PureComponent {
    constructor(props) {
        super(props)

        const { store } = props

        store.breadcrumps = [
            {
                name: 'intranet',
                url: '/intranet',
                title: 'Intranet',
            },
            {
                name: 'licences',
                url: '/intranet/licences',
                title: 'Licences',
            },
        ]

        this.licenceManagerStore = new LicenceManagerStore(store)

        this.state = {
            showHelp: false,
            selectedClient: undefined,
        }
    }

    async componentDidMount() {
        const { store } = this.props
        const { clientId } = store.userData
        const { licenceManagerStore } = this

        await licenceManagerStore.init()

        await this.changeClient({ value: clientId })

        const { clients } = licenceManagerStore
        this.setState({
            selectedClient: clients.find(({ value }) => value === clientId),
        })
    }

    changeClient = async (obj) => {
        const { licenceManagerStore } = this
        const clientId = obj.value

        await Promise.all([
            licenceManagerStore.getLicences(clientId),
            licenceManagerStore.getProductMap(clientId),
        ])

        licenceManagerStore.clientId = clientId

        this.setState({
            selectedClient: obj,
        })
    }

    toggleHelp = () => {
        const { showHelp } = this.state
        this.setState({
            showHelp: !showHelp,
        })
    }

    render() {
        const { showHelp, selectedClient } = this.state
        const { licenceManagerStore } = this
        const { clientId, totalLicences } = licenceManagerStore
        return (
            <div id="licences">
                <Select
                    onBlur={this.changeClient}
                    value={selectedClient}
                    clearable={false}
                    cssClass="defaultDropdown"
                    options={licenceManagerStore.clients}
                />

                <div>
                    <Anchor
                        onClick={this.toggleHelp}
                    >
                        Help
                    </Anchor>
                    {showHelp && (
                        <div
                            style={{
                                padding: '10px',
                                border: '1px solid black',
                                background: '#FFF',
                            }}
                        >
                            The input boxes show red when there are less licences assigned than there are active products in the system. Either archive/delete the products for that producttype or increase the number of licences. The number in square [brackets] indicates the number of products the client can add. If it is negative then the client does not have enough licences to cover what is already active.
                        </div>
                    )}
                </div>
                {
                    Boolean(licenceManagerStore.clientId) && (
                        <div>
                            <h3>Total Licences: {totalLicences}</h3>
                        </div>
                    )
                }
                {
                    Boolean(licenceManagerStore.clientId)
                    && Object.entries(licenceManagerStore.productMap).map(([code, industry]) => (
                        <div>
                            <h3>{industry.name}</h3>
                            <ul className="productList">
                                {
                                    Object.keys(industry.productTypes)
                                        .map((productType) => (
                                            <ProductTypeLicence
                                                key={`${clientId}_${productType}`}
                                                code={code}
                                                licence={licenceManagerStore.getLicence(productType)}
                                                industry={code}
                                                licenceManagerStore={licenceManagerStore}
                                                clientId={clientId}
                                                statuses={this.statuses}
                                            />
                                        ))
                                }
                            </ul>
                        </div>
                    ))
                }
            </div>
        )
    }
}

export default LicenceManager
